// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eo-card__metadata[data-v-3a1d8c3c]{align-items:center;display:flex;justify-content:space-between;width:100%}.eo-card__metadata .eo-like[data-v-3a1d8c3c]{align-items:center;display:flex;justify-content:flex-start}.eo-card:not(.is-image-full) .eo-card__metadata .eo-like[data-v-3a1d8c3c]{color:#666}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
